import { IApp } from '@core/models/app.interfaces';
import { CarbonIntensityTableFilter } from '@core/models/filter-types.model';


export const PATHWAY_MARK_AS_UNDER_REVIEW_PREFIX = 'pathwayMarkAsUnderReview';
export const PATHWAY_APPLICATION_MARK_AS_INVALID_PREFIX = 'pathwayMarkAsInvalid';
export const PATHWAY_APPLICATION_MARK_AS_ACTIVE_PREFIX = 'pathwayMarkAsActive';
export const PATHWAY_CANCEL_PREFIX = 'pathwayCancel';

export const CARBON_INTENSITY_TABLE_DETAILS = {
    tableListApiUri: '/cfr-service/application/pageSearch',
    tableHeaderType: 'CARBON_INTENSITY_SEARCH',
    tableFilter: CarbonIntensityTableFilter,
    hasViewTemple: false,
    hasActionTemple: true,
};

export const CANCELLATION = {
    action: 'CANCEL',
    uiUri: '/pathway/cancel-pathway',
    uri: '/reviewCancellationCarbonIntensity',
    type: 'PATHWAY_CANCELLATION',
    id: 'cancellationId',
    status: 'cancellationStatus',
    prefix: PATHWAY_CANCEL_PREFIX
};

export const REQUEST_PATHWAY_CANCELLATION_ADMIN = {
    action: 'CANCEL',
    uiUri: '/pathway/cancel-pathway',
    uri: '/reviewCancellationCarbonIntensity ',
    type: 'PATHWAY_CANCELLATION',
    id: null,
    status: null,
    prefix: PATHWAY_CANCEL_PREFIX
};

export const REQUEST_PATHWAY_CANCELLATION = {
    action: 'SUBMIT',
    uiUri: '/pathway/cancel-pathway',
    type: 'PATHWAY_CANCELLATION',
    uri: '/cancelCarbonIntensity',
    id: null,
    status: null,
    prefix: PATHWAY_CANCEL_PREFIX,
    actionLabel: 'requestCancellationFor',
};

export const PATHWAY_APPLICATION_MARK_AS_ACTIVE = {
    action: 'CANCEL',
    uiUri: '/pathway/mark-as-active',
    uri: '/markAsActive',
    type: 'CI_PATHWAY',
    id: 'id',
    status: null,
    entityAction: 'mark-as-active',
    prefix: PATHWAY_APPLICATION_MARK_AS_ACTIVE_PREFIX,
    actionLabel: 'MARK_AS_ACTIVE',
};

export const PATHWAY_APPLICATION_MARK_AS_INVALID = {
    action: 'CANCEL',
    uiUri: '/pathway/mark-as-replaced',
    uri: '/markAsInvalid',
    type: 'CI_PATHWAY',
    id: 'id',
    status: null,
    entityAction: 'mark-as-invalid',
    prefix: PATHWAY_APPLICATION_MARK_AS_INVALID_PREFIX,
    actionLabel: 'MARK_AS_REPLACED',
};

export const VIEW_INVALIDATION_REQUEST = {
    ...PATHWAY_APPLICATION_MARK_AS_INVALID,
    entityAction: 'invalid-ci',
    prefix: PATHWAY_APPLICATION_MARK_AS_INVALID_PREFIX
};


export const MARK_UNDER_REVIEW = {
    action: 'CANCEL',
    uiUri: '/carbon-intensity/mark-as-under-review',
    uri: '/markAsUnderReview',
    type: 'CI_PRODUCTION_OF_LOW_CI_FUELS',
    id: 'id',
    entityAction: 'mark-as-under-review',
    status: null,
    prefix: PATHWAY_MARK_AS_UNDER_REVIEW_PREFIX,
    actionLabel: 'MARK_UNDER_REVIEW',
};

export const VIEW_UNDER_REVIEW_REQUEST = {
    ...MARK_UNDER_REVIEW,
    entityAction: 'view-under-review-request',
};

export const VIEW_ACTIVATION_REQUEST = {
    ...PATHWAY_APPLICATION_MARK_AS_ACTIVE,
    entityAction: 'view-activation-request',
    prefix: PATHWAY_CANCEL_PREFIX
};

export const PATHWAY_ACTIONS: IApp.ITableAction = {
    VIEW_PATHWAY_APPLICATION: {
        uiUri: '/submission-management/wizard/application-ci-pathway/${id}',
    },
    VIEW_CANCELLATION: CANCELLATION,
    APPROVE_CANCELLATION: CANCELLATION,
    REVIEW_REQUEST_CANCELLATION: CANCELLATION,
    REJECT_REQUEST_CANCELLATION: CANCELLATION,
    VIEW_INVALIDATION_REQUEST,
    VIEW_REPLACEMENT_REQUEST: VIEW_INVALIDATION_REQUEST,
    MARK_UNDER_REVIEW,
    VIEW_UNDER_REVIEW_REQUEST,
    VIEW_ACTIVATION_REQUEST,
    REQUEST_PATHWAY_CANCELLATION_ADMIN,
    MARK_PATHWAY_AS_INVALID: PATHWAY_APPLICATION_MARK_AS_INVALID,
    MARK_PATHWAY_AS_ACTIVE: PATHWAY_APPLICATION_MARK_AS_ACTIVE,
    REQUEST_PATHWAY_CANCELLATION,
};
